import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=dd8e471a&scoped=true&"
import script from "./item-list.vue?vue&type=script&lang=js&"
export * from "./item-list.vue?vue&type=script&lang=js&"
import style0 from "./item-list.vue?vue&type=style&index=0&id=dd8e471a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8e471a",
  null
  
)

export default component.exports